<template>
  <div class="page home">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title">Austin Studio Tour</span>
      <HeaderNav />
    </div>

    <div class="page-content">
      <!-- APP -->
      <template v-if="$root.app">
        <ArtistSpotlight v-if="$root.artists.length" />
        <div class="menu-links">
          <router-link to="/participants" tag="div" class="link artists">
            <span class="link-title">Participants</span>
            <span class="link-info">Browse artist profiles, filter by media, and save a list of your favorites. </span>
          </router-link>
          <router-link to="/map" tag="div" class="link map">
            <span class="link-title">Interactive Map</span>
            <span class="link-info">Search by area or filter for easy navigating.</span>
          </router-link>
          <router-link to="/events" tag="div" class="link events">
            <span class="link-title">Event Guide</span>
            <span class="link-info">Get details about upcoming events.</span>
          </router-link>
          <router-link to="/participants?favorites=true" tag="div" class="link favorites">
            <span class="link-title">Favorites</span>
            <span class="link-info">View and edit your saved list of artists.</span>
          </router-link>
        </div>
      </template>

      <!-- WEBSITE -->
      <template v-else-if="pageData.acf">
        <Components :components="pageData.acf.components" location="above" />
        <Components :components="pageData.acf.components" location="below" />
        <Footer />
      </template>
    </div>
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

import ArtistSpotlight from '../components/ArtistSpotlight';

export default {
  name: 'Home',
  components: { Components, HeaderNav, Footer, ArtistSpotlight },
  mixins: [SubPageUtils],
  data() {
    return {
      pageData: {},
    }
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/10126?x=2`)
    this.pageData = await pageDataResponse.json();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page-title {
  font-family: @fontSecondary;
}

.app {
  .page-content {
    background-color: #f5f5f5;
    min-height: 100%;
    padding-bottom: calc(~'40px + env(safe-area-inset-bottom)');
  }

  .menu-links {
    padding: 20px 9px;
    .link {
      display: block;
      min-height: 97px;
      margin-bottom: 7px;
      padding: 15px 70px 15px 20px;
      color: #000;
      text-decoration: none;
      background-color: #fff;
      border-radius: 19px;
      background-position: right 20px center;
      background-repeat: no-repeat;
      &.artists {
        background-image: url(../assets/img/icon-artists.svg);
        background-size: 30px 35px;
      }
      &.map {
        background-image: url(../assets/img/icon-map.svg);
        background-size: 30px 38px;
      }
      &.events {
        background-image: url(../assets/img/icon-events.svg);
        background-size: 29px 29px;
      }
      &.favorites {
        background-image: url(../assets/img/icon-fav-theme.svg);
        background-size: 28px 26px;
      }
      &.social {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='29' height='27.31' viewBox='0 0 29 27.31'%3E%3Cg id='Group_382' data-name='Group 382' transform='translate(-477.325 -77.229)'%3E%3Cpath id='Path_76' data-name='Path 76' d='M504.622,105.788H485.278a3.118,3.118,0,0,1-2.953-3.255v-1.721h2.45v1.721c0,.461.265.8.5.8h19.344c.237,0,.5-.344.5-.8V85.484c0-.461-.266-.8-.5-.8H502.6V82.229h2.023a3.118,3.118,0,0,1,2.952,3.255v17.049A3.118,3.118,0,0,1,504.622,105.788Z' transform='translate(-1.249 -1.249)' fill='%23F05377'/%3E%3Cpath id='Path_77' data-name='Path 77' d='M499.622,100.788H480.278a3.118,3.118,0,0,1-2.953-3.255V80.484a3.118,3.118,0,0,1,2.953-3.255h19.344a3.118,3.118,0,0,1,2.952,3.255V97.533A3.118,3.118,0,0,1,499.622,100.788ZM480.278,79.68c-.238,0-.5.344-.5.8V97.533c0,.461.265.8.5.8h19.344c.237,0,.5-.344.5-.8V80.484c0-.461-.266-.8-.5-.8Z' fill='%23F05377'/%3E%3Cg id='Group_381' data-name='Group 381' transform='translate(481.59 85.345)'%3E%3Cpath id='Path_78' data-name='Path 78' d='M483.938,96.561l3.466-3.634,1.849,2.054,5.392-6,4.621,4.819v4.9H483.938Z' transform='translate(-483.242 -88.28)' fill='%23F05377'/%3E%3Cpath id='Path_79' data-name='Path 79' d='M499.034,99.159H483.706a.7.7,0,0,1-.7-.7V96.329a.7.7,0,0,1,.192-.481l3.466-3.634a.724.724,0,0,1,.514-.216.7.7,0,0,1,.508.23l1.33,1.479,4.875-5.428a.7.7,0,0,1,1.021-.017l4.621,4.819a.7.7,0,0,1,.194.482v4.9A.7.7,0,0,1,499.034,99.159ZM484.4,97.766h13.934V93.844l-3.908-4.076-4.89,5.446a.7.7,0,0,1-.518.231h0a.7.7,0,0,1-.518-.23l-1.346-1.5L484.4,96.608Z' transform='translate(-483.01 -88.048)' fill='%23F05377'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A");
        background-size: 28px 26px;
      }
      &:active {
        background-color: darken(#fff, 5%);
      }
      .link-title {
        display: block;
        margin-bottom: 5px;
        font-size: 25px;
        font-weight: bold;
      }
      .link-info {
        font-size: 14px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue